interface RiasecInfoProps {
  quality: string;
  hoverClass: string;
}

const RiasecInfo: React.FC<RiasecInfoProps> = ({ quality, hoverClass }) => {
  quality = quality.toLowerCase();

  if (quality == 'realistic') {
    return (
      <div className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Realistic: </span>Realistic people tend to
          have athletic interests, prefer to work with objects, machines, tools,
          plants or animals, and like to be outdoors.
        </p>
        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-4 list-disc">
          <li>
            Be independent, practical, systematic, self-controlled, and
            straightforward
          </li>
          <li>
            Like to work outdoors, be physically active, work on electronic
            equipment, train animals, and build things
          </li>
          <li>
            Be able to play a sport, fix things, operate tools and machinery,
            plant a garden, camp outdoors
          </li>
        </ul>
      </div>
    );
  }

  if (quality == 'investigative') {
    return (
      <div className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Investigative: </span> Investigative
          people like to observe, learn, investigate, analyze, and solve
          problems.
        </p>
        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-4 list-disc">
          <li>be logical, curious, thoughtful, observant, and intellectual</li>
          <li>
            like to work independently, explore ideas, analyze data, explain
            scientific theories, or perform experiments
          </li>
          <li>
            be able to think abstractly, interpret formulas, use a computer or
            microscope, or solve complex problems
          </li>
        </ul>
      </div>
    );
  }

  if (quality == 'artistic') {
    return (
      <div className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Artistic: </span> Artistic people like to
          work in unstructured situations using their imagination and
          creativity.
        </p>
        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-4 list-disc">
          <li>
            be creative, imaginative, unconventional, expressive, innovative,
            and impulsive
          </li>
          <li>
            like to work on crafts, take photos, attend concerts, art exhibits,
            and plays, or enjoy reading fiction
          </li>
          <li>
            be able to sing, play an instrument, act or dance, draw or paint,
            create designs, or write stories, poetry and music
          </li>
        </ul>
      </div>
    );
  }

  if (quality == 'social') {
    return (
      <div className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Social: </span>  Social people like to work with people to inspire, inform, help, train or cure them.
        </p>

        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-2 list-disc">
          <li>be patient, insightful, responsible, cooperative, outgoing, and skilled with words</li>
          <li>
            like to work in groups, volunteer, solve personal problems, or serve your community
          </li>
          <li>
            be able to teach others, mediate, lead a discussion, communicate well, or plan and supervise activities          </li>
        </ul>
      </div>
    );
  }

  if (quality == 'enterprising') {
    return (
      <section className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Enterprising: </span>Enterprising people
          like to work with people to influence, persuade and lead them, and to
          achieve organizational or financial goals.
        </p>
        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-4 list-disc">
          <li>be assertive, energetic, persuasive, ambitious, or optimistic</li>
          <li>
            like to make decisions, take on leadership roles, meet influential
            people, or run campaigns
          </li>
          <li>
            be able to initiate projects, give speeches, persuade or inspire
            others, lead a large group, or develop organizational goals
          </li>
        </ul>
      </section>
    );
  }

  if (quality == 'conventional') {
    return (
      <section className={`${hoverClass}`}>
        <p>
          <span className="font-bold">Conventional: </span> Conventional people
          like to work with information, carry out detailed tasks, and have
          clerical or numerical interests.
        </p>
        <p className="mt-1.5 font-bold">At work and at home, you may:</p>
        <ul className="ml-4 list-disc">
          <li>
            be efficient, well-organized, persistent, methodical, or
            conscientious
          </li>
          <li>
            like to follow a plan, organize information, work with numbers, use
            a computer, or collect data
          </li>
        </ul>
      </section>
    );
  }
  return <></>;
};

export default RiasecInfo;
